// Action item summary status colors
export const ACTION_ITEM_SUMMARY_COLORS = {
  OVERDUE: '#DC2626',    // Red
  ALL_DONE: '#16A34A',   // Green
  PENDING: '#6B7280',    // Gray
  DEFAULT: '#2563EB',    // Blue
};
